import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { func, shape, string } from 'prop-types';
import Router from './router';
import { initializeSentry } from './utils/sentry';
import { flattenMessages, intlFormat } from './utils/i18n';
import defaultMessages from './locales/translation.json';

// eslint-disable-next-line camelcase
const App = ({ baseRoute, store, locale, sentryDSN, sentryEnv }) => {
  const [messages, setMessages] = useState(defaultMessages);
  const clientLocale = locale.replace('_', '-');

  if (sentryDSN && sentryEnv) {
    initializeSentry({
      dsn: sentryDSN,
      environment: sentryEnv,
      release: process.env.SENTRY_RELEASE_VERSION,
      locale,
    });
  }

  useEffect(() => {
    function getTranslations() {
      if (
        typeof window.tesla !== 'undefined' &&
        typeof window.tesla.App !== 'undefined' &&
        typeof window.tesla.App.strings !== 'undefined'
      ) {
        const translations = window.tesla.App.strings;
        setMessages(translations);
      }
    }
    getTranslations();
  }, []);

  return (
    <Provider store={store}>
      <IntlProvider formats={intlFormat} locale={clientLocale} messages={flattenMessages(messages)}>
        <Router baseRoute={baseRoute} />
      </IntlProvider>
    </Provider>
  );
};

App.propTypes = {
  baseRoute: string,
  store: shape({
    subscribe: func.isRequired,
    dispatch: func.isRequired,
    getState: func.isRequired,
  }).isRequired,
  locale: string,
  sentryDSN: string,
  sentryEnv: string,
};

App.defaultProps = {
  baseRoute: '/',
  locale: 'en_US',
  sentryDSN: '',
  sentryEnv: '',
};

export default App;
